import { render } from "./AppMain.vue?vue&type=template&id=3b7bc43c&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=ts"
export * from "./AppMain.vue?vue&type=script&lang=ts"

import "./AppMain.vue?vue&type=style&index=0&id=3b7bc43c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3b7bc43c"

export default script